import Spacer from '@/common/components/spacer';
import { cn } from '@/shadcn-ui/utils';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('skeleton rounded-md', className)} {...props} />;
}

function H3Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className="flex flex-col">
      <Spacer variant="height2" />
      <Skeleton className={cn('h-[20px]', className)} {...props} />
    </div>
  );
}

function BodySkeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className="flex flex-col">
      <Spacer variant="height2" />
      <Skeleton className={cn('h-[22px]', className)} {...props} />
    </div>
  );
}

interface Body2SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * If true, we increase the height of the Spacer to 4px to make
   * the multi-line Skeleton look more like a paragraph.
   */
  multiLine?: boolean;
}

function Body2Skeleton({ className, multiLine = false, ...props }: Body2SkeletonProps) {
  if (multiLine) {
    return (
      <div className="flex flex-col">
        <Spacer variant="height4" />
        <Skeleton className={cn('h-[16px]', className)} {...props} />
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      <Spacer variant="height2" />
      <Skeleton className={cn('h-[18px]', className)} {...props} />
    </div>
  );
}

interface Body3SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * If true, we increase the height of the Spacer to 4px to make
   * the multi-line Skeleton look more like a paragraph.
   */
  multiLine?: boolean;
}

function Body3Skeleton({ className, multiLine = false, ...props }: Body3SkeletonProps) {
  if (multiLine) {
    return (
      <div className="flex flex-col">
        <Spacer variant="height4" />
        <Skeleton className={cn('h-[14px]', className)} {...props} />
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      <Spacer variant="height2" />
      <Skeleton className={cn('h-[16px]', className)} {...props} />
    </div>
  );
}

export { Skeleton, H3Skeleton, BodySkeleton, Body2Skeleton, Body3Skeleton };
